import io from 'socket.io-client'
import store from '../store'
import { showToast, refreshGold } from '@/utils/tool'
import i18n from '@/i18n'

export default {
  install(Vue, options) {
    Vue.prototype.$socket = {
      client: null,
      init: function() {
        if (this.client) {
          return
        }

        const socketioUrl = process.env.VUE_APP_ENV === 'production'
          ? process.env.VUE_APP_NOTIFY // 正式站
          : process.env.VUE_APP_NOTIFY_DEV // 測試站

        console.log('Connecting to Socket.IO server:', socketioUrl)

        try {
          this.client = io(socketioUrl, {
            transports: ['websocket'],
            withCredentials: false,
            reconnectionAttempts: 3, // 1 次主連線 + 3 次重試
            reconnectionDelay: 1000,
            timeout: 5000
          })

          const client = this.client

          // 添加連接錯誤處理
          this.client.on('connect_error', (error) => {
            console.error('Socket.IO connection error:', error)
          })

          this.client.on('connect_timeout', () => {
            console.error('Socket.IO connection timeout')
          })

          this.client.on('error', (error) => {
            console.error('Socket.IO error:', error)
          })

          // socketio內建event
          // 建立連線
          this.client.on('connect', function() {
            console.log('Socket connected with ID:', client.id)

            // 連接後進行認證
            if (store.getters.token) {
              console.log('Authenticating with token')
              client.emit('auth', { token: store.getters.token })
            }
          })

          // 認證成功回調
          this.client.on('authed', function() {
            console.log('Socket authentication successful')
          })

          // 重新連線
          this.client.on('reconnect', function(attemptNumber) {
            console.log('Socket reconnected after', attemptNumber, 'attempts')
            // 重連後重新認證
            if (store.getters.token) {
              client.emit('auth', { token: store.getters.token })
            }
          })

          // 斷線重連
          this.client.on('disconnect', function(reason) {
            console.log('Socket disconnected. Reason:', reason)
          })

          // 關閉重連
          this.client.on('close', function(event) {
            console.log('Socket closed')
          })

          // 接收聊天訊息
          this.client.on('chat_recv', function(message) {
            console.log('Chat message received:', message)
          })

          // 新增 notify 事件監聽 - 接收伺服器通知回調
          this.client.on('notify', function(data) {
            console.log('Notification received:', data)

            // 確認回調格式是否正確
            if (!data || !data.data.cmd || !data.data.params || !data.data.user_id || !data.msg) {
              console.error('Invalid notification format:', data)
              return
            }

            // 處理不同類型的通知
            switch (data.data.cmd) {
              case 'deposit': {
                const { amount } = data.data.params
                const toastMessage = `${amount} ${i18n.t('Bao.notify_socket')}`
                showToast(toastMessage, null, true, false)
                refreshGold('multi_wallet')

                break
              }

              default:
                console.log(`Unknown notification command: ${data.data.cmd}`)
                break
            }
          })
        } catch (e) {
          console.error('Failed to initialize socket connection:', e)
        }
      },
      reinit: function() {
        console.log('Reinitializing socket connection')

        if (this.client) {
          this.client.close()
          this.client = null
        }

        this.init()
      },
      close: function() {
        console.log('Closing socket connection')

        if (this.client) {
          this.client.close()
          this.client = null
        }
      }
    }
  }
}
